"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["size", "spacing", "icon", "spin", "className", "prefix"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Fa = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Fa, _React$Component);

  var _super = _createSuper(Fa);

  function Fa() {
    (0, _classCallCheck2["default"])(this, Fa);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Fa, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          spacing = _this$props.spacing,
          icon = _this$props.icon,
          spin = _this$props.spin,
          className = _this$props.className,
          prefix = _this$props.prefix,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var sizeStr = null;
      var sizeNum = parseInt(size);

      if (sizeNum === 1) {
        sizeStr = "fa-lg";
      } else if (sizeNum > 1) {
        sizeStr = "fa-" + size + "x";
      }

      var spacingClass = {};
      spacingClass["mr-" + spacing] = spacing;

      if (!prefix) {
        prefix = "fas";
      }

      return /*#__PURE__*/_react["default"].createElement("i", (0, _extends2["default"])({
        className: (0, _classnames["default"])(prefix, "fa-" + icon, spacingClass, sizeStr, {
          "fa-spin": spin
        }, className),
        "aria-hidden": "true"
      }, rest));
    }
  }]);
  return Fa;
}(_react["default"].Component);

exports["default"] = Fa;
Fa.propTypes = {
  icon: _propTypes["default"].string.isRequired,
  spacing: _propTypes["default"].number,
  size: _propTypes["default"].number,
  spin: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
Fa.defaultProps = {
  spacing: null,
  size: 0,
  spin: false
};